module.exports = __webpack_public_path__ + "static/media/pic_4.66ccb182.jpg";